<template>
  <div class="transport-from">
    <el-form
      ref="form"
      :model="form"
      label-width="90px"
      style="padding-right: 12px"
      :class="{ 'info-from': viewOpType }"
      :label-suffix="viewOpType ? '' : ''"
    >
      <div class="guide-all-one" v-if="categoryTip">
        <div  class="guidance-content "  >
          如果您还没有维护品类，可以点击【设置】按钮，去维护品类哦~
          <gj-button @click="categoryTip = !categoryTip" class="content-btn"
            >我知道了</gj-button
          >
        </div>
        <div class="overall-guidance">
          <div class="leader"></div>
          <div class="guiding-point"></div>
        </div>
      </div>
      <div class="guide-all-two" v-if="brandTip">
        <div class="guidance-content">
          如果您还没有维护品牌，可以点击【设置】按钮，去维护品牌哦~
          <gj-button @click="brandTip = !brandTip" class="content-btn"
            >我知道了</gj-button
          >
        </div>
        <div class="overall-guidance">
          <div class="leader"></div>
          <div class="guiding-point"></div>
        </div>
      </div>
      <div class="flex justify-between">
        <el-form-item
          label="品类"
          prop="categoryId"
          :rules="[
            {
              required: !viewOpType,
              message: '请选择品类',
              trigger: ['blur', 'change'],
            },
          ]"
          class="setting-wrapper setting-flex">
          <template v-if="viewOpType">{{
            form.categoryName | defaultShow
          }}</template>
          <template v-else>
            <gj-category-select
              v-model="form.categoryId"
              active
              noValid
              class="form-input"
              placeholder="品类"
              :clearable="false"
            >
            </gj-category-select>
            <div
              class="setting-icon"
              :style="categoryTip ? { visibility: 'visible' } : null"
              @click="$router.push({ path: '/product/product-category' })"
            >
              <gj-icon class="el-icon-setting"> </gj-icon>
            </div>
          </template>
        </el-form-item>
        <el-form-item
          label="品牌"
          prop="brandId"
          class="setting-wrapper setting-flex"
        >
          <template v-if="viewOpType">{{
            form.brandName | defaultShow
          }}</template>
          <template v-else>
            <gj-brand-select
              v-model="form.brandId"
              active
              class="form-input"
              placeholder="品牌"
            ></gj-brand-select>
            <div
              class="setting-icon"
              :style="brandTip ? { visibility: 'visible' } : null"
              @click="$router.push({ path: '/product/product-brand' })"
            >
              <gj-icon class="el-icon-setting"> </gj-icon>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="单位" prop="unit" class="setting-wrapper">
          <template v-if="viewOpType">{{ form.unit | defaultShow }}</template>
          <gj-input
            v-else
            v-model="form.unit"
            class="form-input"
            placeholder="不填则默认为PCS"
          ></gj-input>
        </el-form-item>
        <el-form-item label="状态" prop="state" class="setting-wrapper">
          <template v-if="viewOpType">{{
            form.state | optionText(ProductEnum.statusOption) | defaultShow
          }}</template>
          <gj-select
            v-else
            v-model="form.state"
            :options="ProductEnum.statusOption"
            class="form-input"
            :clearable="false"
          ></gj-select>
        </el-form-item>
      </div>

      <el-row>
        <el-col :span="6">
          <el-form-item label="产品开发" prop="developer">
            <template v-if="viewOpType">{{
              form.productDeveloper | defaultShow
            }}</template>
            <gj-creator-select
              v-else
              v-model="form.productDeveloperId"
              class="form-input"
              placeholder="产品开发"
              active
            ></gj-creator-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="产品描述" prop="description">
          <template v-if="viewOpType">
            <div v-html="getDesc(form.description)"></div>
          </template>
          <gj-textarea
            v-else
            v-model="form.description"
            :rows="4"
            placeholder="请简单描述，字数不超过1024个字符"
          ></gj-textarea>
        </el-form-item>
      </el-row>
      <el-row v-if="productType === ProductEnum.type.ASSEMBLY">
        <el-form-item class="not-mg">
          <template #label>
            <span v-if="!viewOpType" style="color: #f56c6c; margin-right: 4px"
              >*</span
            >包含产品
          </template>
          <gj-button v-if="!viewOpType" type="text" @click="addChildProduct"
            >+ 添加产品</gj-button
          >
          <gj-table
            :index="false"
            :data="form.childProducts"
            :columns="columns"
            :height="290"
            :adaptHeight="false"
            :show-pagination="false"
            :size="'has-picture'"
            errorColumn
          >
            <template v-slot:sku="{ row }">
              <div>{{ row.sku }}</div>
              <div>
                <gj-tooltip :text-line="1" :content="row.name">
                  {{ row.name | defaultShow }}
                </gj-tooltip>
              </div>
            </template>
            <template v-slot:quantity="{ index }">
              <el-form-item
                :prop="`childProducts.${index}.quantity`"
                :rules="[
                  {
                    required: true,
                    message: '请输入数量',
                    trigger: ['blur', 'change'],
                  },
                  $gjReRule(RE.pt, '请输入正整数'),
                ]"
                class="gj-table-item"
              >
                <template v-if="viewOpType">{{
                  form.childProducts[index].quantity
                }}</template>
                <gj-input
                  v-else
                  v-model="form.childProducts[index].quantity"
                  width="100px"
                >
                </gj-input>
              </el-form-item>
            </template>
            <template v-slot:op="{ index }">
              <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
            </template>
          </gj-table>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import AppChildProductAddModal from "./child-product-add-modal";
import { ProductEnum } from "../../../../../../utils/options";
import {
  formDeleteItemMixin,
  formRuleMixin,
  formValidatorMixin,
  opTypeMixin,
} from "../../../../../../minxins";
import {mapGetters} from "vuex";
import { isMeaningful, unique } from "../../../../../../utils/common";

export default {
  name: "app-product-base-form",
  mixins: [formValidatorMixin, formRuleMixin, opTypeMixin],
  props: {
    mountTo: {
      required: true,
    },
    productType: {
      required: true,
    },
    form: {
      required: true,
    },
  },
  data() {
    return {
      visible: true,
      columns: [],
      ProductEnum: ProductEnum,
      categoryTip: true,
      brandTip: true
    };
  },
  created() {
    this.columns = [
      {
        id: "picture",
        header: "图片",
        field: "picture:smallImageUrl",
        minWidth: "60px",
      },
      {
        id: "sku",
        header: "SKU/产品名称",
        field: "slot:sku",
        minWidth: "200px",
      },
      {
        id: "quantity",
        header: "数量",
        field: "slot:quantity",
        required: !this.viewOpType,
        minWidth: "60px",
      },
      this.viewOpType
        ? null
        : {
            id: "op",
            header: "操作",
            field: "slot:op",
            minWidth: "50px",
            notCustomColumn: true,
          },
    ].filter((e) => e !== null);
  },
  computed: {
    ...mapGetters(['activeProductBrandOptions', 'activeProductCategoryTree']),
  },
  watch:  {
    activeProductBrandOptions:  {
      immediate: true,
      handler( value ){
        this.brandTip = !(value && value.length > 0)
      }
    },
    activeProductCategoryTree:  {
      immediate:true,
      handler( value ){
        // 内置品类
        let preset = ['个护清洁', '其他', '图文娱乐', '宠物用品', '家具厨具', '手机和配件', '服装与饰品', '母婴童装', '汽车用品', '玩具乐器', '电脑办公', '美妆护肤', '运动户外', '钟表珠宝', '鞋靴']
        let flag = value.find(item => !preset.includes(item.label))
        // 判断
        this.categoryTip = !(value && value.length > 0) || !isMeaningful(flag)
      }
    }
  },
  methods: {
    addChildProduct() {
      const hideSkuList = this.form.childProducts.map((item) => item.sku);
      const modal = this.$gjCreate(AppChildProductAddModal, {
        mountTo: this.mountTo,
        props: {
          hideSkuList,
        },
        on: {
          select: (products) => {
            this.form.childProducts = unique(
              [].concat(products || []).concat(this.form.childProducts),
              "sku"
            );
          },
        },
      });
    },
    deleteItem(index) {
      this.form.childProducts.splice(index, 1);
    },
    getDesc(desc) {
      if (isMeaningful(desc)) {
        return desc.replace(/\n/g, "<br />");
      }
      return "-";
    },
  },
};

</script>

<style scoped lang="scss">
.form-input {
  width: 170px !important;
}
.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  visibility: hidden;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 4px;
}
.setting-wrapper {
  position: relative;
  box-sizing: border-box;
  width: 25%;
  flex: none;
}
/deep/ .setting-wrapper + .el-form-item {
  .el-form-item__label {
    //width: 55px!important;
  }
  .el-form-item__content {
    //margin-left: 55px!important;
  }
}
.setting-wrapper:hover .setting-icon {
  visibility: visible;
  line-height: 1;
}
.transport-from {
  height: 100%;
  overflow: auto;
  padding: 0;
  margin-right: 0;
}
.info-from {
  /deep/.el-form-item__label,
  /deep/.el-form-item__content {
    line-height: 20px;
  }
  /deep/ .el-form-item {
    margin-bottom: 12px;
  }
}
.setting-flex {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .setting-icon {
    position: static;
    margin-left: 8px;
  }
}
.not-mg {
  margin-bottom: 0;
}
.guide-all-one {
  position: absolute;
  left: 85px;
  top: 13px;
  .guidance-content {
    background: #4994fc;
    color: #fff;
    z-index: 1000;
    border-radius: 4px;
    width: 190px;
    padding: 15px;
    position: absolute;
    top: 85px;
    left: 80px;
    .content-btn {
      color: #fff;
      margin-top: 10px;
      margin-left: 110px;
      border: #fff solid 1px;
      background: #4994fc;
      &:hover {
        background: #4c8bf2;
        border: #fff solid 1px;
      }
    }
  }
  .overall-guidance {
    position: absolute;
    left: 190px;
    .leader {
      width: 0;
      border: #4994fc solid 1px;
      height: 150px;
    }
    .guiding-point {
      position: absolute;
      top: 0;
      left: -3px;
      border: 1px solid #4994fc;
      background-color: #4994fc;
      // display: inline-block; // 此句为css样式展示重点🏁
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
}
.guide-all-two {
  position: absolute;
  left: 372px;
  top: 13px;
  .guidance-content {
    background: #4994fc;
    color: #fff;
    z-index: 1000;
    border-radius: 4px;
    width: 190px;
    padding: 15px;
    position: absolute;
    top: 85px;
    left: 80px;
    .content-btn {
      color: #fff;
      margin-top: 10px;
      margin-left: 110px;
      border: #fff solid 1px;
      background: #4994fc;
      &:hover {
        background: #4c8bf2;
        border: #fff solid 1px;
      }
    }
  }
  .overall-guidance {
    position: absolute;
    left: 190px;
    .leader {
      width: 0;
      border: #4994fc solid 1px;
      height: 150px;
    }
    .guiding-point {
      position: absolute;
      top: 0;
      left: -3px;
      border: 1px solid #4994fc;
      background-color: #4994fc;
      // display: inline-block; // 此句为css样式展示重点🏁
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
}
</style>
